import request from '@/utils/request'
export function getDomain() {
    return request({
        url: '/saas/saascompanysetting/getCompanySettingStatisticsList',
        method: 'get'
    })
}
